module.exports = __webpack_public_path__ + "static/media/NS PP - 2020 NOVO PORTI.3e711316.pdf";